import { render, staticRenderFns } from "./PolicyContentItem.vue?vue&type=template&id=7c3c97c9&scoped=true&"
import script from "./PolicyContentItem.vue?vue&type=script&lang=js&"
export * from "./PolicyContentItem.vue?vue&type=script&lang=js&"
import style0 from "./PolicyContentItem.vue?vue&type=style&index=0&id=7c3c97c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3c97c9",
  null
  
)

export default component.exports